module.exports = __webpack_public_path__ + "static/media/addClientIcon.0fed3178.svg";